module.exports = __webpack_public_path__ + "media/images/headphone-29a3f95ab81c315027ea3445daf175d4.svg";